export const ru = {
    confirmation: 'Подтверждение',
    hotel_name: 'Название отеля',
    hotel_type: 'Тип отеля',
    price_per_night: 'Цена за ночь',
    recommended: 'Рекомендованный',
    stars_count: 'Количество звезд',
};
